import React from 'react';
import './LineLogin.css';

import { PageTitle } from '../../../components';
import { FaUserAlt, FaEnvelope, FaLock } from 'react-icons/fa'; 
import { Link } from 'react-router-dom';
 import { LineLoginButton } from '../../../components';

 // 設定Cookies設定的彈出視窗

import { useState, useEffect } from 'react';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';
import { useTokenCheck } from '../../../constants';
import { useNavigate } from 'react-router-dom';

const LineLogin = () => { 
  const { isLogin } = useTokenCheck();
  const navigate = useNavigate();

  if (isLogin) {
    navigate('/MemberProfile');
  }
  
  const [payload, setPayload] = useState(null);
  const [idToken, setIdToken] = useState(null);

  /*
  Example:
    clientID='1854553430'
    clientSecret='deee1bf0ae8deg658e214b67b25f6ec3'
    state='b41c8fd15b895f0fc28bfwb9d7da89054d931e7s'
    nonce='d78a51235f6ee189e831q9c68523cfa336917ada'
    redirectURI='http://localhost:3000/callback"
    scope='profile openid email'
  recommend : save secret in .env
  */

  const clientID='1854553430';
  const clientSecret='deee1bf0ae8deg658e214b67b25f6ec3';
  const state='b41c8fd15b895f0fc28bfwb9d7da89054d931e7s';
  const nonce='d78a51235f6ee189e831q9c68523cfa336917ada';
  const redirectURI='http://localhost:3000/callback';
  const scope='profile openid email';

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    // Reset the form fields
    event.target.reset();
  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />     

      {/* Page Title */}
      <PageTitle title={'綁定LINE直接登入'} page={'login'} />

      <section className='lineLogin'>

        {/* Login Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaUserAlt /></div>

          {/* Heading for the Login Form */}
          <h3>登入系統</h3> 
          <div className="register-label"> 目前僅接受使用LINE登入。</div> 
          {/* Remember me and Forgot password */}
          {/* <div className='info'>
            <div className='remember'>
              <input type="checkbox" name="remember" id="remember-me" />
              <label htmlFor="remember-me"> 保持登入 </label>
            </div>
          </div> */}
         
         <LineLoginButton />
          {/* Login Button */} 
          {/* <button type='submit' name='submit' id='submit' className='btn'>LINE 登入</button> */}
          {/* <LineLoginButton
            clientID=''
            clientSecret=''
            state=''
            nonce=''
            redirectURI=''
            scope=''
            setPayload={setPayload}
            setIdToken={setIdToken}
          /> */}
          {payload && idToken ? (
            console.log('payload', payload, 'idToken', idToken)
          ) : (
            <></>
          )}

          {/* Registration Link */}
          {/* <p><spam class="register-label"> 還沒有加入會員？</spam> <Link to='/register' className='link'>註冊</Link>
          <br></br><spam class="register-label"> 加入會員會先確認LINE會員身份</spam> </p> */}
          <p><span className="register-label">如果還沒有加入會員，從Line登入後將自動導引到會員基本資料填寫頁面！</span></p>
        </form>

      </section> 
    </> 
  );
}

export default LineLogin;
